import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { StockMovementsApiAdapter } from '@modules/Reports/StockMovements/adapters/StockMovementsApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const adapter = new StockMovementsApiAdapter(httpClient);

export const useOrderStockMovements = (orderId?: number, enabled = true) => {
  return useQuery({
    queryKey: ['orderStockMovements', orderId],
    queryFn: async () => {
      if (!orderId) return { stockmovements: [], total: 0 };

      return adapter.getStockMovementsPaginated({
        page: 1,
        limit: 50,
        advanced_filters: {
          filters: [{ column: 'order_id', operator: 'in', value: [orderId] }],
          logic: 'AND',
        },
      });
    },
    enabled: Boolean(orderId) && enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
